module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(!_vm.ready) ? _c('div', {
    staticClass: "loading__login"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "info text-center"
  }, [_c('h4', {
    staticClass: "text-uppercase"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.info.msg) + "\n     ")]), _vm._v(" "), _c('h5', [_vm._v("\n        " + _vm._s(_vm.info.subMsg) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "id": "info-button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cerrar")])])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "dismiss-button",
      "data-dismiss": "modal"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "custom-loading-color fa fa-spinner fa-spin fa-5x fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c05fd1d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/LoginModal.vue
// module id = 1703
// module chunks = 6